export default __webpack_public_path__ + "../images/apple-touch-icon-120x120.png";